import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ModalController, NavParams, NavController } from '@ionic/angular';

import { Browser } from '@capacitor/browser';

@Component({
    selector: 'app-modal-iframe',
    templateUrl: './modal-iframe.component.html',
    styleUrls: ['./modal-iframe.component.scss'],
    standalone: false
})
export class ModalIframeComponent implements OnInit
{


	@Input() title: string;
	@Input() html: string;
	// @Input() url: string;
	@Input() back: boolean = false;
	@Input() buttons: [];
	@Input() light: boolean = false;


	constructor(
		public modalController: ModalController,
		public navParams: NavParams,
		public domSanitizer: DomSanitizer,
		public navCtrl: NavController,
		public renderer: Renderer2,
		private elementRef: ElementRef,
	)
	{
	}

	public ngOnInit()
	{
		this.SetTrustedHtml();
	}

	safeHtml: SafeHtml;

	public SetTrustedHtml()
	{
		this.safeHtml = this.domSanitizer.bypassSecurityTrustHtml(this.html);
	}


	@ViewChild('htmldiv') htmldiv: ElementRef;
	public anchorEventListener: () => void;
	ngAfterViewInit()
	{
		if (this.html)
		{
			const nativeEl = this.htmldiv.nativeElement;
			this.anchorEventListener = this.renderer.listen(nativeEl, 'click', (event) =>
			{
				if (event.target instanceof HTMLAnchorElement)
				{
					if (event.srcElement.href.startsWith("https") || event.srcElement.href.startsWith("https:"))
					{
						// Prevent opening anchors the default way
						event.preventDefault();

						// Your custom anchor click event handler
						this.handleAnchorClick(event.srcElement.href);
					}
				}
			});
		}
	}

	public async handleAnchorClick(href: string)
	{
		// console.log(href);
		if (href.startsWith("https://app.motorcentral.co.nz/"))
		{
			this.navCtrl.navigateForward(href.replace("https://app.motorcentral.co.nz/", ""));
		}
		else if (href.startsWith("https://localhost:8100/"))
		{
			this.navCtrl.navigateForward(href.replace("https://localhost:8100/", ""));
		}
		else
		{
			await Browser.open({ url: href });
		}
		this.dismissModal("nav");
	}

	public ngOnDestroy()
	{
		if (this.html)
		{
			//destroy the anchor event listener
			this.anchorEventListener();
		}
	}
	public dismissModal(button: any)
	{
		if (button.disabled) return;
		// Dismiss the top modal returning some data object
		this.modalController.dismiss({
			'result': button.name
		});
	}

	scrollTop: boolean = true;
	ionScrollEvent(ev:any){
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop!=scrollTop) {
			this.scrollTop = scrollTop;
		}
	}
}
